import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const LinkedinInvitationIcon = ({
  color = colors.black,
  className,
  onClick,
  style,
  size = 16,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...style}
    >
      <path
        d="M4 16H9.93961C9.75802 15.5912 9.75802 14.6667 9.75802 14.6667H4C2.5296 14.6667 1.33333 13.4704 1.33333 12V4C1.33333 2.5296 2.5296 1.33333 4 1.33333H12C13.4704 1.33333 14.6667 2.5296 14.6667 4V11.5C15 11.6858 15.5 11.6858 15.9526 12.8019C15.9838 12.601 16 12.2094 16 12V4C16 1.7944 14.2056 0 12 0H4C1.7944 0 0 1.7944 0 4V12C0 14.2056 1.7944 16 4 16Z"
        fill={color}
      />
      <path
        d="M11.1064 15.1647V10.9C11.1064 10.5548 11.3863 10.275 11.7314 10.275C12.0766 10.275 12.3564 10.5548 12.3564 10.9V15.1647C12.3562 15.5097 12.0765 15.7897 11.7314 15.7897C11.3864 15.7897 11.1067 15.5097 11.1064 15.1647Z"
        fill={color}
      />
      <path
        d="M9.59766 12.4073H13.8623C14.2075 12.4073 14.4873 12.6872 14.4873 13.0323C14.4873 13.3775 14.2075 13.6573 13.8623 13.6573H9.59766C9.25267 13.6571 8.97266 13.3774 8.97266 13.0323C8.97266 12.6873 9.25267 12.4076 9.59766 12.4073Z"
        fill={color}
      />
      <path
        d="M5.73372 6.6064V11.3333C5.73372 11.7015 5.43519 12 5.06706 12C4.69892 12 4.40039 11.7015 4.40039 11.3333V6.6064C4.40039 6.23827 4.69892 5.93974 5.06706 5.93974C5.43519 5.93974 5.73372 6.23827 5.73372 6.6064ZM5.06706 3.73334C4.69892 3.73334 4.40039 4.03187 4.40039 4.4V4.53334C4.40039 4.90147 4.69892 5.2 5.06706 5.2C5.43519 5.2 5.73372 4.90147 5.73372 4.53334V4.4C5.73372 4.03187 5.43519 3.73334 5.06706 3.73334ZM10.6029 6.02907C9.93652 5.89814 9.11386 6.07214 8.39719 6.63627C8.38039 6.28307 8.09106 6.00107 7.73372 6.00107C7.36559 6.00107 7.06706 6.2996 7.06706 6.66774V11.3333C7.06706 11.7015 7.36559 12 7.73372 12C8.10186 12 8.40039 11.7015 8.40039 11.3333V8.84627C8.40812 8.83094 8.41786 8.8172 8.42452 8.80094C8.88199 7.682 9.73719 7.2176 10.3459 7.3372C10.8043 7.4272 11.0671 7.84254 11.0671 8.47654V9.26855C11.444 9.03306 12.1006 9 12.4004 9.26855V8.47667C12.4004 7.2044 11.6948 6.2436 10.6029 6.02907Z"
        fill={color}
      />
    </svg>
  );
};

export default LinkedinInvitationIcon;
